<template>
  <div class="create_wrapper fadeIn">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>
      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="tw-justify-start tw-items-center tw-my-8">
            <div class="">
              <label for="project"> عرض في الموقع </label>
              <input
                type="checkbox"
                class="form-check-input"
                name="category"
                id="project"
                value="true"
                v-model="data.is_active"
              />
            </div>
          </div>

          <div class="row justify-content-between product">
            <v-expansion-panels>
              <!-- ======= Start Project Main Section =======  -->
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h5>البيانات الاساسية للمشروع</h5>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="col-8 mx-auto">
                        <uplode-image
                          @inputChanged="uploadMainImageSectionAr($event)"
                          placeHolder=" أضف صورة للسكشن الاساسي (عربي)"
                        ></uplode-image>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="col-8 mx-auto">
                        <uplode-image
                          @inputChanged="uploadMainImageSection($event)"
                          placeHolder=" أضف صورة للسكشن الاساسي (أنجليزي)"
                        ></uplode-image>
                      </div>
                    </div>
                    <!-- Project Name Input -->
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @input="helper_checkIfInputIsEmpty"
                          @keypress="isArabic"
                          v-model.trim="data.name_ar"
                        />
                        <label for="name_input" class="form-label"
                          >اسم المشروع(عربي)</label
                        >
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @keypress="isEnglish"
                          v-model.trim="data.name_en"
                        />
                        <label for="name_input" class="form-label"
                          >اسم المشروع(انجليزي )</label
                        >
                      </div>
                    </div>
                    <!-- <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @input="helper_checkIfInputIsEmpty"
                          @keypress="isArabic"
                          v-model.trim="data.title_ar"
                        />
                        <label for="name_input" class="form-label"
                          >فئة المشروع(عربي)</label
                        >
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @keypress="isEnglish"
                          v-model.trim="data.title_en"
                        />
                        <label for="name_input" class="form-label"
                          >فئة المشروع(انجليزي )</label
                        >
                      </div>
                    </div> -->
                    <!-- Project region Input -->
                    <div class="col-lg-12 py-0">
                      <div class="col-6 me-auto">
                        <uplode-image
                          @inputChanged="uploadFlagImage($event)"
                          placeHolder=" أضف صورة لعلم الدولة  "
                        ></uplode-image>
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @keypress="isArabic"
                          v-model.trim="data.location_ar"
                        />
                        <label for="name_input" class="form-label"
                          >دولة المشروع(عربي)</label
                        >
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @keypress="isEnglish"
                          v-model.trim="data.location_en"
                        />
                        <label for="name_input" class="form-label"
                          >دولة المشروع(انجليزي )</label
                        >
                      </div>
                    </div>
                    <!-- Project Download Number Input -->
                    <div class="col-lg-4 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="number"
                          class="form-control"
                          @input="helper_checkIfInputIsEmpty"
                          v-model.trim="data.downloads"
                        />
                        <label for="name_input" class="form-label">
                          عدد مرات تحميل المشروع
                        </label>
                      </div>
                    </div>

                    <!-- Project Platforms Input -->
                    <div class="col-lg-4 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @keypress="isArabic"
                          v-model.trim="data.platforms_ar"
                        />
                        <label for="name_input" class="form-label"
                          >المنصات (عربي)</label
                        >
                      </div>
                    </div>
                    <div class="col-lg-4 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @keypress="isEnglish"
                          v-model.trim="data.platforms_en"
                        />
                        <label for="name_input" class="form-label"
                          >المنصات (انجليزي)</label
                        >
                      </div>
                    </div>

                    <!-- Project description Input -->

                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <label for="textarea_1" class="form-label"
                          >نبذة مختصرة عن المشروع(عربي)</label
                        >
                        <textarea
                          class="form-control"
                          rows="4"
                          v-model="data.description_ar"
                          @keypress="isArabic"
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <label for="textarea_1" class="form-label"
                          >نبذة مختصرة عن المشروع(انجليزي)</label
                        >
                        <textarea
                          class="form-control"
                          rows="4"
                          v-model="data.description_en"
                          @keypress="isEnglish"
                        ></textarea>
                      </div>
                    </div>
                    <!-- Project colors Inputs -->
                    <!-- Project Ratting Number Input -->
                    <div class="col-lg-4 py-0 mx-auto">
                      <div class="input_wrapper top_label">
                        <input
                          type="number"
                          class="form-control"
                          @input="helper_checkIfInputIsEmpty"
                          v-model.trim="data.ratings"
                        />
                        <label for="name_input" class="form-label">
                          تقيم المشروع
                        </label>
                      </div>
                    </div>
                    <span
                      >لاحظ ان االالوان الثلاث الاولة خاصة بعرض المشروع في
                      الصفحة الرئيسية
                    </span>
                    <div
                      class="col-lg-4 py-0"
                      v-for="(background, index) in data.backgrounds"
                      :key="index"
                    >
                      <div class="input_wrapper top_label">
                        <input
                          type="color"
                          class="form-control"
                          v-model.trim="background.bg"
                        />
                        <label for="name_input" class="form-label"
                          >اللون رقم {{ index + 1 }}
                        </label>
                        <!-- <label for="name_input" class="form-label"  v-if="index==1">اللون الثاني</label> -->
                        <!-- <label for="name_input" class="form-label"  v-if="index==2">اللون الثالث</label> -->
                      </div>
                    </div>
                    <!-- Project Download Number Input -->
                    <div class="col-lg-6 py-0 mx-auto">
                      <!-- START:: DATE PICKER INPUT -->
                      <div class="input_wrapper top_label date_input">
                        <label class="form-label">سنة الانشاء</label>
                        <multiselect
                          v-model="data.founded_in"
                          :options="manufactruingYears"
                          label="name"
                          track-by="id"
                          placeholder=""
                          :searchable="true"
                          :allow-empty="true"
                          :show-labels="false"
                        >
                          <template slot="option" slot-scope="props">
                            <!-- <img
                                      class="option__image"
                                      :src="props.option.image"
                                    /> -->
                            <span class="option__title">
                              {{ props.option.name }}
                            </span>
                          </template>
                        </multiselect>
                      </div>
                    </div>
                    <!-- Project ordering Number Input -->
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="number"
                          class="form-control"
                          @input="helper_checkIfInputIsEmpty"
                          v-model.trim="data.ordering"
                        />
                        <label for="name_input" class="form-label">
                          ترتيب المشروع
                        </label>
                      </div>
                    </div>
                    <!-- Project ordering Input -->
                  </div>
                  <!-- END:: DATE PICKER INPUT -->
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- ======= End Project Main Section =======  -->

              <!-- ======= Start  What is Project Section =======  -->
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h5>ماهو المشروع</h5>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="col-8 mx-auto">
                        <uplode-image
                          @inputChanged="uploadAboutImageSectionAr($event)"
                          placeHolder=" صورة للمشروع (عربي) "
                        ></uplode-image>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="col-8 mx-auto">
                        <uplode-image
                          @inputChanged="uploadAboutImageSection($event)"
                          placeHolder=" صورة للمشروع (أنجليزي) "
                        ></uplode-image>
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <label for="textarea_1" class="form-label"
                          >ماهو المشروع(عربي)</label
                        >
                        <textarea
                          class="form-control"
                          rows="4"
                          v-model="data.about_project_ar"
                          @keypress="isArabic"
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <label for="textarea_1" class="form-label"
                          >ماهو المشروع(انجليزي)</label
                        >
                        <textarea
                          class="form-control"
                          rows="4"
                          v-model="data.about_project_en"
                          @keypress="isEnglish"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- ======= End What is Project Sections =======  -->

              <!-- ======= Start  main Features Section =======  -->
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h5>الجزء الخاص بمميزات المشروع</h5>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                  <div class="row">
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @input="helper_checkIfInputIsEmpty"
                          @keypress="isArabic"
                          v-model.trim="data.feature_title_ar"
                        />
                        <label for="name_input" class="form-label"
                          >عنوان السكشن (عربي)</label
                        >
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @keypress="isEnglish"
                          v-model.trim="data.feature_title_en"
                        />
                        <label for="name_input" class="form-label"
                          >عنوان السكشن (انجليزي )</label
                        >
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <label for="textarea_1" class="form-label">
                          الوصف(عربي)</label
                        >
                        <textarea
                          class="form-control"
                          rows="4"
                          @keypress="isArabic"
                          v-model="data.feature_description_ar"
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <label for="textarea_1" class="form-label"
                          >الوصف (انجليزي)</label
                        >
                        <textarea
                          class="form-control"
                          rows="4"
                          @keypress="isEnglish"
                          v-model="data.feature_description_en"
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <h3>اضف بعض الصور للمشروع</h3>
                      <span>(عربي)</span>
                      <div class="col-lg-12 py-0 row">
                        <div
                          class="col-4"
                          v-for="index in 3"
                          :key="`FeatureAr${index}`"
                        >
                          <uplode-image
                            @inputChanged="uploadFeatureImagesAr($event, index)"
                            placeHolder=" ا ضف صورة  "
                          ></uplode-image>
                        </div>
                      </div>
                      <span>(أنجليزي)</span>
                      <div class="col-lg-12 py-0 row">
                        <div
                          class="col-4"
                          v-for="index in 3"
                          :key="`Feature${index}`"
                        >
                          <uplode-image
                            @inputChanged="uploadFeatureImages($event, index)"
                            placeHolder=" ا ضف صورة   "
                          ></uplode-image>
                        </div>
                      </div>
                    </div>
                    <h3>أضف مميزات للمشروع</h3>
                    <div class="col-10 row">
                      <div
                        class="col-lg-6"
                        v-for="(feature, index) in data.main_features"
                        :key="index"
                      >
                        <div class="col-lg-12 py-0">
                          <uplode-image
                            @inputChanged="uploadMainFeatures($event, index)"
                            placeHolder="أضف icon   "
                          ></uplode-image>
                        </div>
                        <div class="col-lg-12 py-0">
                          <div class="input_wrapper top_label">
                            <input
                              type="text"
                              class="form-control"
                              @keypress="isArabic"
                              v-model.trim="feature.title_ar"
                            />
                            <label for="name_input" class="form-label"
                              >الميزة (عربي )</label
                            >
                          </div>
                        </div>
                        <div class="col-lg-12 py-0">
                          <div class="input_wrapper top_label">
                            <input
                              type="text"
                              class="form-control"
                              @keypress="isEnglish"
                              v-model.trim="feature.title_en"
                            />
                            <label for="name_input" class="form-label"
                              >الميزة ( انجليزي)</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Actions -->
                    <div
                      class="col-1 py-0"
                      v-if="data.main_features.length > 0"
                    >
                      <span class="append" @click="appendMainFeature()">
                        <i class="fas fa-plus-circle"></i>
                      </span>
                    </div>
                    <div
                      class="col-1 py-0"
                      v-show="data.main_features.length > 1"
                    >
                      <span class="append" @click="deleteMainFeature()">
                        <i class="fas fa-minus-circle"></i>
                      </span>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- ======= End main Features Sections =======  -->

              <!-- ======= Start Splash Sections =======  -->
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h5>الصور المتحركة للمشروع</h5>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                  <div class="row">
                    <h5>السكشن الاول</h5>
                    <span>(عربي)</span>
                    <div
                      class="col-lg-4"
                      v-for="index in 3"
                      :key="`Splash1Ar${index}`"
                    >
                      <div class="col-9">
                        <uplode-image
                          @inputChanged="uploadSplashImages1Ar($event, index)"
                          placeHolder="أضف صورة"
                        ></uplode-image>
                      </div>
                    </div>
                    <span>(أنجليزي)</span>
                    <div
                      class="col-lg-4"
                      v-for="index in 3"
                      :key="`Splash1En${index}`"
                    >
                      <div class="col-9">
                        <uplode-image
                          @inputChanged="uploadSplashImages1($event, index)"
                          placeHolder="أضف صورة"
                        ></uplode-image>
                      </div>
                    </div>
                    <h5>السكشن الثاني</h5>
                    <span>(عربي)</span>
                    <div
                      class="col-lg-4"
                      v-for="index in 3"
                      :key="`Splash2Ar${index}`"
                    >
                      <div class="col-9">
                        <uplode-image
                          @inputChanged="uploadSplashImages2Ar($event, index)"
                          placeHolder=" أضف صورة"
                        ></uplode-image>
                      </div>
                    </div>
                    <span>(أنجليزي)</span>
                    <div
                      class="col-lg-4"
                      v-for="index in 3"
                      :key="`Splash2En${index}`"
                    >
                      <div class="col-9">
                        <uplode-image
                          @inputChanged="uploadSplashImages2($event, index)"
                          placeHolder=" أضف صورة"
                        ></uplode-image>
                      </div>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- ======= Start  Splash Sections =======  -->

              <!-- ======= Start  Project Provide Sections =======  -->
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h5>ماذا فعلنا في المشروع</h5>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                  <div class="row">
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <label for="name_input" class="form-label">
                          اشرح ماذا فعلنا (عربي)</label
                        >
                        <textarea
                          class="form-control"
                          rows="4"
                          @keypress="isArabic"
                          v-model="data.project_done_description_ar"
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <label for="name_input" class="form-label"
                          >اشرح ماذا فعلنا (انجليزي )</label
                        >
                        <textarea
                          class="form-control"
                          rows="4"
                          @keypress="isEnglish"
                          v-model="data.project_done_description_en"
                        ></textarea>
                      </div>
                    </div>
                    <h3>اضف بعض صور المشروع</h3>
                    <span>(عربي)</span>
                    <div class="col-lg-12 py-0 row">
                      <div
                        class="col-3"
                        v-for="index in 4"
                        :key="`ProjectDoneen${index}`"
                      >
                        <uplode-image
                          @inputChanged="
                            uploadProjectDoneSectionAr($event, index)
                          "
                          placeHolder=" ا ضف صورة   "
                        ></uplode-image>
                      </div>
                    </div>
                    <span>(أنجليزي)</span>
                    <div class="col-lg-12 py-0 row">
                      <div
                        class="col-3"
                        v-for="index in 4"
                        :key="`ProjectDone${index}`"
                      >
                        <uplode-image
                          @inputChanged="
                            uploadProjectDoneSection($event, index)
                          "
                          placeHolder=" ا ضف صورة   "
                        ></uplode-image>
                      </div>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- ======= End What we Did Sections =======  -->
              <!-- ======= Start What we Provide Sections =======  -->
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h5>ماذا يقدم المشروع</h5>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                  <div class="row">
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @keypress="isArabic"
                          @input="helper_checkIfInputIsEmpty"
                          v-model.trim="data.project_provide_title_ar"
                        />
                        <label for="name_input" class="form-label"
                          >عنوان السكشن (عربي)</label
                        >
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @keypress="isEnglish"
                          v-model.trim="data.project_provide_title_en"
                        />
                        <label for="name_input" class="form-label"
                          >عنوان السكشن (انجليزي )</label
                        >
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <label for="textarea_1" class="form-label">
                          المحتوي(عربي)</label
                        >
                        <textarea
                          class="form-control"
                          rows="4"
                          @keypress="isArabic"
                          v-model="data.project_provide_description_ar"
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <label for="textarea_1" class="form-label"
                          >المحتوي (انجليزي)</label
                        >
                        <textarea
                          class="form-control"
                          rows="4"
                          @keypress="isEnglish"
                          v-model="data.project_provide_description_en"
                        ></textarea>
                      </div>
                    </div>
                    <div class="">
                      <h3>اضف بعض الصور للمشروع</h3>
                      <span>(عربي)</span>
                      <div class="col-lg-12 py-0 row">
                        <div
                          class="col-4"
                          v-for="index in 3"
                          :key="`ProjectPresentAr${index}`"
                        >
                          <uplode-image
                            @inputChanged="
                              uploadwhatProjectPresentSectionAr($event, index)
                            "
                            placeHolder=" ا ضف صورة   "
                          ></uplode-image>
                        </div>
                      </div>
                      <span>(أنجليزي)</span>
                      <div class="col-lg-12 py-0 row">
                        <div
                          class="col-4"
                          v-for="index in 3"
                          :key="`ProjectPresent${index}`"
                        >
                          <uplode-image
                            @inputChanged="
                              uploadwhatProjectPresentSection($event, index)
                            "
                            placeHolder=" ا ضف صورة   "
                          ></uplode-image>
                        </div>
                      </div>
                      <!-- uploadFeatureImages -->
                    </div>
                    <h3>المميزات</h3>
                    <div class="col-10 row">
                      <div
                        class="col-lg-6"
                        v-for="(feature,
                        index) in data.project_provide_features"
                        :key="index"
                      >
                        <div class="col-lg-12 py-0">
                          <uplode-image
                            @inputChanged="
                              uploadWhatProjectProvideFeatures($event, index)
                            "
                            placeHolder="أضف icon   "
                          ></uplode-image>
                        </div>
                        <div class="col-lg-12 py-0">
                          <div class="input_wrapper top_label">
                            <input
                              type="text"
                              class="form-control"
                              @keypress="isArabic"
                              v-model.trim="feature.title_ar"
                            />
                            <label for="name_input" class="form-label"
                              >الميزة (عربي )</label
                            >
                          </div>
                        </div>
                        <div class="col-lg-12 py-0">
                          <div class="input_wrapper top_label">
                            <input
                              type="text"
                              class="form-control"
                              @keypress="isEnglish"
                              v-model.trim="feature.title_en"
                            />
                            <label for="name_input" class="form-label"
                              >الميزة ( انجليزي)</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Actions -->
                    <div
                      class="col-1 py-0"
                      v-if="data.project_provide_features.length > 0"
                    >
                      <span
                        class="append"
                        @click="appendProjectProvideFeature()"
                      >
                        <i class="fas fa-plus-circle"></i>
                      </span>
                    </div>
                    <div
                      class="col-1 py-0"
                      v-show="data.project_provide_features.length > 1"
                    >
                      <span
                        class="append"
                        @click="deleteProjectProvideFeature()"
                      >
                        <i class="fas fa-minus-circle"></i>
                      </span>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- ======= End main Features Sections =======  -->
            </v-expansion-panels>

            <!--Start  Project Tools Inputs -->

            <div class="tw-mt-8 tw-w-full">
              <div class="input_wrapper">
                <label class="form-label">الادوات</label>
                <multiselect
                  v-model="data.tools"
                  :options="tools"
                  label="title"
                  track-by="id"
                  placeholder=""
                  :searchable="true"
                  :allow-empty="true"
                  :show-labels="false"
                  multiple
                >
                  <template slot="option" slot-scope="props">
                    <img class="option__image" :src="props.option.image" />
                    <span class="option__title">
                      {{ props.option.title }}
                    </span>
                  </template>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="tw-mt-8 tw-w-full">
            <div class="input_wrapper">
              <label class="form-label">القسم</label>
              <multiselect
                v-model="data.category"
                :options="categories"
                label="name"
                track-by="id"
                placeholder=""
                :searchable="true"
                :allow-empty="true"
                :show-labels="false"
              >
                <template slot="option" slot-scope="props">
                  <span class="option__title">
                    {{ props.option.name }}
                  </span>
                </template>
              </multiselect>
            </div>
          </div>
        </div>
        <!--End  Project Tools Inputs -->
        <div class="buttons_wrapper">
          <button class="base-btn">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",
  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.projects.title"),
          disabled: false,
          href: "/projects",
        },
        {
          text: this.$t("breadcrumb.projects.add"),
          disabled: true,
          href: "",
        },
      ],
      menu: false,
      // ========== Loading
      btnIsLoading: false,
      data: {
        image: null,
        category: null,
        image_ar: null,
        ordering: null,
        name_ar: null,
        name_en: null,
        title_ar: null,
        title_en: null,
        flag: null,
        location_ar: null,
        location_en: null,
        downloads: null,
        platforms_ar: null,
        platforms_en: null,
        description_ar: null,
        description_en: null,
        founded_in: null,
        ratings: null,
        is_active: null,
        // Background Colors
        backgrounds: [
          {
            bg: null,
          },
          {
            bg: null,
          },
          {
            bg: null,
          },
          {
            bg: null,
          },
          {
            bg: null,
          },
          {
            bg: null,
          },
        ],
        first_splashes: [],
        second_splashes: [],
        first_splashes_ar: [],
        second_splashes_ar: [],
        tools: [],
        // Start About Data
        about_image: null,
        about_image_ar: null,
        about_project_ar: null,
        about_project_en: null,
        // End About Data

        // Start  Features Section Data
        feature_description_en: null,
        feature_description_ar: null,
        feature_title_en: null,
        feature_title_ar: null,
        feature_images: [],
        feature_images_ar: [],
        main_features: [
          {
            icon: null,
            title_ar: null,
            title_en: null,
          },
        ],
        // End Features Section Data

        // Start What The Project Present
        project_done_images: [],
        project_done_images_ar: [],
        project_done_description_ar: null,
        project_done_description_en: null,
        // End What the Project Present

        // Start What The Project Provide
        project_provide_images: [],
        project_provide_images_ar: [],
        project_provide_title_en: null,
        project_provide_title_ar: null,
        project_provide_description_ar: null,
        project_provide_description_en: null,
        project_provide_features: [
          {
            icon: null,
            title_ar: null,
            title_en: null,
          },
        ],
        // End What The Project Provide
      },

      // =====All tools data
      tools: [],
      categories: [],
    };
  },

  computed: {
    manufactruingYears() {
      let max = new Date().getFullYear();
      let min = max - 30;
      let years = [];
      for (let i = max; i >= min; i--) {
        years.push({ id: i, name: i, value: i });
      }
      return years;
    },
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  methods: {
    //     Start     -------------   Upload  Ar  Images
    uploadMainImageSectionAr(img) {
      this.data.image_ar = img.img_file;
    },
    uploadAboutImageSectionAr(img) {
      this.data.about_image_ar = img.img_file;
    },
    uploadSplashImages1Ar(img, index) {
      this.data.first_splashes_ar[index] = img.img_file;
    },
    uploadSplashImages2Ar(img, index) {
      this.data.second_splashes_ar[index] = img.img_file;
    },
    uploadProjectDoneSectionAr(img, index) {
      this.data.project_done_images_ar[index] = img.img_file;
    },
    uploadwhatProjectPresentSectionAr(img, index) {
      this.data.project_provide_images_ar[index] = img.img_file;
    },
    uploadFeatureImagesAr(img, index) {
      this.data.feature_images_ar[index] = img.img_file;
    },
    //   Start       -------------   Upload  En Images
    uploadMainImageSection(img) {
      this.data.image = img.img_file;
    },
    uploadFlagImage(img) {
      this.data.flag = img.img_file;
      console.log(this.data.flag, "flag");
    },
    uploadAboutImageSection(img) {
      this.data.about_image = img.img_file;
    },
    uploadSplashImages1(img, index) {
      this.data.first_splashes[index] = img.img_file;
    },
    uploadSplashImages2(img, index) {
      this.data.second_splashes[index] = img.img_file;
    },
    uploadProjectDoneSection(img, index) {
      this.data.project_done_images[index] = img.img_file;
    },
    uploadwhatProjectPresentSection(img, index) {
      this.data.project_provide_images[index] = img.img_file;
    },
    uploadWhatProjectProvideFeatures(img, index) {
      this.data.project_provide_features[index].icon = img.img_file;
    },
    uploadFeatureImages(img, index) {
      this.data.feature_images[index] = img.img_file;
      console.log(this.data.feature_images);
    },
    appendProjectProvideFeature() {
      this.data.project_provide_features.push({
        icon: null,
        title_ar: null,
        title_en: null,
      });
    },
    deleteProjectProvideFeature() {
      this.data.project_provide_features.splice(-1);
    },
    save(date) {
      this.$refs.menu.save(date);
    },
    uploadMainFeatures(img, index) {
      this.data.main_features[index].icon = img.img_file;
    },
    appendMainFeature() {
      this.data.main_features.push({
        icon: null,
        title_ar: null,
        title_en: null,
      });
    },
    deleteMainFeature() {
      this.data.main_features.splice(-1);
    },
    validateCreateForm() {
      this.btnIsLoading = true;
      let validate = false;
      if (!this.data.image) {
        this.$iziToast.error({
          timeout: 2000,
          message: "الصورة في البيانات الاساسية مطلوبة",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.name_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  أسم المشروع  مطلوب (عربي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.name_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  أسم المشروع  مطلوب (أنجليزي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
        // } else if (!this.data.title_ar) {
        //   this.$iziToast.error({
        //     timeout: 2000,
        //     message: "  فئة المشروع  مطلوبة (عربي ) ",
        //     position: "bottomRight",
        //   });
        //   this.btnIsLoading = false;
        //   return;
        // } else if (!this.data.title_en) {
        //   this.$iziToast.error({
        //     timeout: 2000,
        //     message: "  فئة المشروع  مطلوبة (أنجليزي ) ",
        //     position: "bottomRight",
        //   });
        //   this.btnIsLoading = false;
        //   return;
      } else if (!this.data.location_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  دولة المشروع  مطلوبة (عربي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.location_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  دولة المشروع  مطلوبة (أنجليزي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.downloads) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  عدد مرات  تحميل  المشروع  مطلوب ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.platforms_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  المنصات   مطلوبة (عربي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.platforms_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  المنصات   مطلوبة (أنجليزي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.ratings) {
        this.$iziToast.error({
          timeout: 2000,
          message: " تقيم المشروع  مطلوب  ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.data.ratings > 5 || this.data.ratings < 0) {
        this.$iziToast.error({
          timeout: 2000,
          message: " تقيم المشروع يجب ان يكون من 0 الي 5   ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.ordering) {
        this.$iziToast.error({
          timeout: 2000,
          message: " ترتيب المشروع مطلوب   ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.data.ordering < 1) {
        this.$iziToast.error({
          timeout: 2000,
          message: " ترتيب المشروع يجب ان يكون أكبر  من 0    ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.description_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  النبذة المختصرة  مطلوبة (عربي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.description_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  النبذة المختصرة  مطلوبة (أنجليزي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.category) {
        this.$iziToast.error({
          timeout: 2000,
          message: "القسم مطلوب",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        if (validate) return;
        this.data.backgrounds.map((background, index) => {
          if (validate) return;
          if (!background.bg) {
            this.$iziToast.error({
              timeout: 2000,
              message: `أدخل اللون رقم ${index + 1}`,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          }
        });
        if (!this.data.founded_in) {
          this.$iziToast.error({
            timeout: 2000,
            message: " سنة الانشاء مطلوبة",
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.about_image) {
          this.$iziToast.error({
            timeout: 2000,
            message: " أَضف الصورة في سكشن ماهو المشروع",
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.about_project_ar) {
          this.$iziToast.error({
            timeout: 2000,
            message: "  محتوي وصف المشروع في سكشن ماهو المشروع مطلوب (عربي ) ",
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.about_project_en) {
          this.$iziToast.error({
            timeout: 2000,
            message:
              "  محتوي وصف المشروع في سكشن ماهو المشروع مطلوب (أنجليزي ) ",
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.feature_title_ar) {
          this.$iziToast.error({
            timeout: 2000,
            message: "  العنوان  في سكشن مميزات المشروع مطلوب (عربي ) ",
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.feature_title_en) {
          this.$iziToast.error({
            timeout: 2000,
            message: "  العنوان  في سكشن مميزات المشروع مطلوب (أنجليزي ) ",
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.feature_description_ar) {
          this.$iziToast.error({
            timeout: 2000,
            message: "  الوصف  في سكشن مميزات المشروع مطلوب (عربي ) ",
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.feature_description_en) {
          this.$iziToast.error({
            timeout: 2000,
            message: "  الوصف  في سكشن مميزات المشروع مطلوب (أنجليزي ) ",
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
          // }
        } else if (!this.data.feature_images[1]) {
          this.$iziToast.error({
            timeout: 2000,
            message: `أدخل الصورة  رقم 1 في سكشن مميزات المشروع`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.feature_images[2]) {
          this.$iziToast.error({
            timeout: 2000,
            message: `أدخل الصورة  رقم 2 في سكشن مميزات المشروع`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.feature_images[3]) {
          this.$iziToast.error({
            timeout: 2000,
            message: `أدخل الصورة  رقم 3 في سكشن مميزات المشروع`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        }
        this.data.main_features.map((features, index) => {
          if (validate) return;
          if (!features.icon) {
            this.$iziToast.error({
              timeout: 2000,
              message: `أدخل icon الميزة  رقم ${
                index + 1
              } في سكشن مميزات المشروع`,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          } else if (!features.title_ar) {
            this.$iziToast.error({
              timeout: 2000,
              message: ` عنوان الميزة رقم ${
                index + 1
              } في سكشن مميزات المشروع مطلوب (عربي)`,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          } else if (!features.title_en) {
            this.$iziToast.error({
              timeout: 2000,
              message: ` عنوان الميزة رقم ${
                index + 1
              } في سكشن مميزات المشروع مطلوب (أنجليزي)`,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          }
        });
        if (validate) return;
        if (!this.data.first_splashes[1]) {
          this.$iziToast.error({
            timeout: 2000,
            message: ` أضف الصورة رقم  1 في الجزء الاول من الصور المتحركة`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.first_splashes[2]) {
          this.$iziToast.error({
            timeout: 2000,
            message: ` أضف الصورة رقم 2 في الجزء الاول من الصور المتحركة`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.first_splashes[3]) {
          this.$iziToast.error({
            timeout: 2000,
            message: ` أضف الصورة رقم  3 في الجزء الاول من الصور المتحركة`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.second_splashes[1]) {
          this.$iziToast.error({
            timeout: 2000,
            message: ` أضف الصورة رقم  1 في الجزء الثاني من الصور المتحركة`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.second_splashes[2]) {
          this.$iziToast.error({
            timeout: 2000,
            message: ` أضف الصورة رقم 2 في الجزء الثاني من الصور المتحركة`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.second_splashes[3]) {
          this.$iziToast.error({
            timeout: 2000,
            message: ` أضف الصورة رقم  3 في الجزء الثاني من الصور المتحركة`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.project_done_description_ar) {
          this.$iziToast.error({
            timeout: 2000,
            message: `  الوصف في سكشن ماذا فعلنا في المشروع مطلوب (عربي)`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.project_done_description_en) {
          this.$iziToast.error({
            timeout: 2000,
            message: `  الوصف في سكشن ماذا فعلنا في المشروع مطلوب (أنجليزي)`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.project_done_images[1]) {
          this.$iziToast.error({
            timeout: 2000,
            message: ` أضف الصورة رقم  1 في سكشن ماذا فعلنا في المشروع`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.project_done_images[2]) {
          this.$iziToast.error({
            timeout: 2000,
            message: ` أضف الصورة رقم 2 في سكشن ماذا فعلنا في المشروع`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.project_done_images[3]) {
          this.$iziToast.error({
            timeout: 2000,
            message: ` أضف الصورة رقم  3 في سكشن ماذا فعلنا في المشروع`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.project_done_images[4]) {
          this.$iziToast.error({
            timeout: 2000,
            message: ` أضف الصورة رقم  4 في سكشن ماذا فعلنا في المشروع `,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.project_provide_title_ar) {
          this.$iziToast.error({
            timeout: 2000,
            message: `  العنوان في سكشن ماذا يقدم المشروع مطلوب (عربي)`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.project_provide_title_en) {
          this.$iziToast.error({
            timeout: 2000,
            message: `  العنوان في سكشن ماذا يقدم المشروع مطلوب (أنجليزي)`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.project_provide_description_ar) {
          this.$iziToast.error({
            timeout: 2000,
            message: `  الوصف في سكشن ماذا يقدم المشروع مطلوب (عربي)`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.project_provide_description_en) {
          this.$iziToast.error({
            timeout: 2000,
            message: `  الوصف في سكشن ماذا يقدم المشروع مطلوب (أنجليزي)`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.project_provide_images[1]) {
          this.$iziToast.error({
            timeout: 2000,
            message: ` أضف الصورة رقم  1 في سكشن ماذا يقدم المشروع`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.project_provide_images[2]) {
          this.$iziToast.error({
            timeout: 2000,
            message: ` أضف الصورة رقم 2 في سكشن ماذا يقدم المشروع`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.project_provide_images[3]) {
          this.$iziToast.error({
            timeout: 2000,
            message: ` أضف الصورة رقم  3 في سكشن ماذا يقدم المشروع`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        }
        this.data.project_provide_features.map((features, index) => {
          if (validate) return;
          if (!features.icon) {
            this.$iziToast.error({
              timeout: 2000,
              message: `أدخل icon الميزة  رقم ${
                index + 1
              } في سكشن ماذا يقدم المشروع`,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          } else if (!features.title_ar) {
            this.$iziToast.error({
              timeout: 2000,
              message: ` عنوان الميزة رقم ${
                index + 1
              } في سكشن ماذا يقدم المشروع مطلوب (عربي)`,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          } else if (!features.title_en) {
            this.$iziToast.error({
              timeout: 2000,
              message: ` عنوان الميزة رقم ${
                index + 1
              } في سكشن ماذا يقدم  المشروع مطلوب (أنجليزي)`,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          }
        });
        if (validate) return;
        if (!this.data.tools.length) {
          this.$iziToast.error({
            timeout: 2000,
            message: `اختر الادوات`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else {
          this.submitData();
          return;
        }
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      //  ---------------   Start Uplaod Images in ar
      submit_data.append("image_ar", this.data.image_ar);
      submit_data.append(`about_image_ar`, this.data.about_image_ar);
      this.data.first_splashes_ar.forEach((item, index) => {
        submit_data.append(`first_splashes_ar[${index}]`, item);
      });

      this.data.second_splashes_ar.forEach((item, index) => {
        submit_data.append(`second_splashes_ar[${index}]`, item);
      });

      this.data.feature_images_ar.forEach((item, index) => {
        submit_data.append(`feature_images_ar[${index}]`, item);
      });

      this.data.project_done_images_ar.forEach((item, index) => {
        submit_data.append(`done_images_ar[${index}]`, item);
      });

      this.data.project_provide_images_ar.forEach((item, index) => {
        submit_data.append(`provide_images_ar[${index}]`, item);
      });
      // ---------------    Start Uplaod Images in en
      submit_data.append("image", this.data.image);
      submit_data.append(`about_image`, this.data.about_image);
      this.data.first_splashes.forEach((item, index) => {
        submit_data.append(`first_splashes[${index}]`, item);
      });
      this.data.second_splashes.forEach((item, index) => {
        submit_data.append(`second_splashes[${index}]`, item);
      });

      this.data.feature_images.forEach((item, index) => {
        submit_data.append(`feature_images[${index}]`, item);
      });

      this.data.project_done_images.forEach((item, index) => {
        submit_data.append(`done_images[${index}]`, item);
      });
      this.data.project_provide_images.forEach((item, index) => {
        submit_data.append(`provide_images[${index}]`, item);
      });
      // ---------------   End Uplaod Images in en
      submit_data.append("ar[location]", this.data.location_ar);
      submit_data.append("en[location]", this.data.location_en);

      submit_data.append("ar[name]", this.data.name_ar);
      submit_data.append("en[name]", this.data.name_en);

      submit_data.append("ordering", this.data.ordering);

      // submit_data.append("ar[title]", this.data.title_ar);
      // submit_data.append("en[title]", this.data.title_en);
      submit_data.append("category_id", this.data.category.id);

      submit_data.append("is_active", +this.data.is_active);

      submit_data.append("ar[platforms]", this.data.platforms_ar);
      submit_data.append("en[platforms]", this.data.platforms_en);

      submit_data.append("ar[description]", this.data.description_ar);
      submit_data.append("en[description]", this.data.description_en);

      submit_data.append("founded_in", this.data.founded_in.value);
      submit_data.append("flag", this.data.flag);
      submit_data.append("downloads", this.data.downloads);
      submit_data.append("ratings", this.data.ratings);

      this.data.backgrounds.forEach((item, index) => {
        submit_data.append(`backgrounds[${index}][bg]`, item.bg);
        if (index <= 2) {
          submit_data.append(`backgrounds[${index}][key]`, "index");
        } else {
          submit_data.append(`backgrounds[${index}][key]`, "show");
        }
      });

      this.data.tools.forEach((tool, index) => {
        submit_data.append(`tools[${index}]`, tool.id);
      });

      submit_data.append(`ar[about_project]`, this.data.about_project_ar);

      submit_data.append(`en[about_project]`, this.data.about_project_en);

      submit_data.append(`ar[feature_title]`, this.data.feature_title_ar);
      submit_data.append(`en[feature_title]`, this.data.feature_title_en);

      submit_data.append(
        `ar[feature_description]`,
        this.data.feature_description_ar
      );
      submit_data.append(
        `en[feature_description]`,
        this.data.feature_description_en
      );

      this.data.main_features.forEach((feature, index) => {
        submit_data.append(`main_features[${index}][icon]`, feature.icon);
        submit_data.append(
          `main_features[${index}][ar][title]`,
          feature.title_ar
        );
        submit_data.append(
          `main_features[${index}][en][title]`,
          feature.title_en
        );
      });

      submit_data.append(
        `ar[project_done_description]`,
        this.data.project_done_description_ar
      );
      submit_data.append(
        `en[project_done_description]`,
        this.data.project_done_description_en
      );

      submit_data.append(
        `ar[project_provide_title]`,
        this.data.project_provide_title_ar
      );
      submit_data.append(
        `en[project_provide_title]`,
        this.data.project_provide_title_en
      );

      submit_data.append(
        `ar[project_provide_description]`,
        this.data.project_provide_description_ar
      );
      submit_data.append(
        `en[project_provide_description]`,
        this.data.project_provide_description_en
      );

      this.data.project_provide_features.forEach((feature, index) => {
        submit_data.append(
          `project_provide_features[${index}][icon]`,
          feature.icon
        );
        submit_data.append(
          `project_provide_features[${index}][ar][title]`,
          feature.title_ar
        );
        submit_data.append(
          `project_provide_features[${index}][en][title]`,
          feature.title_en
        );
      });
      this.axios({
        method: "POST",
        url: "project",
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("addSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/projects" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
    // get Technologies
    getTools() {
      this.loading = true;
      this.axios({
        method: "GET",
        url: "tools_without_pagination",
      })
        .then((res) => {
          this.tools = res.data.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getCategories() {
      this.loading = true;
      this.axios({
        method: "GET",
        url: "project-categories-without-paginate",
      })
        .then((res) => {
          this.categories = res.data.data;
        })
        .catch(() => {});
    },
  },

  mounted() {
    this.getTools();
    this.getCategories();
  },
};
</script>

<style lang="scss" scoped>
.product {
  .chooseImage {
    width: auto !important;
  }
}
.border_main_color {
  border: 1px solid var(--mainColor-2_2);
  padding-block: 30px;
  border-radius: 15px;
  margin-block: 15px;
  h3 {
    margin-block-end: 10px;
  }
}
.productDetails {
  border: 1px solid #339989;
  border-radius: 15px;
  padding-block: 20px;

  &.disabled {
    cursor: not-allowed;

    h3 {
      color: gray;
      font-size: 25px;
    }

    h4 {
      font-size: 21px;
      color: gray;
    }

    & > * {
      pointer-events: none;
    }
  }
}
</style>
